
import { useAuth, useOrgSettings } from "@/services";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageHeader",
  props: {
    username: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    logoUrl: {
      type: String,
      default: require("@/assets/gamma_logo.png"),
    },
    defaultColor: {
      type: String,
      default: "#17a2b8",
    },
  },
  computed: {
    localDate(): string {
      return this.date || new Date().toLocaleString("en-IE");
    },
    user(): string {
      return this.username || useAuth().user?.email
        ? useAuth().user?.email
        : "";
    },
    clientStyles(): any {
      return useOrgSettings().applicationSettings?.clientStyles;
    },
    logo(): string {
      return this.clientStyles?.logo
        ? this.clientStyles?.logo
        : require("@/assets/gamma_logo.png");
    },
    borderColor(): string | undefined {
      return this.clientStyles?.color ? this.clientStyles?.color : "#17a2b8";
    },
  },
});
